import { render, staticRenderFns } from "./Co2TransportWidgetComponent.vue?vue&type=template&id=5d6b4685&"
import script from "./Co2TransportWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./Co2TransportWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports